// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { TripAreaRoutes } from '@backoffice-frontend/trip-api'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { TripAreaId } from './TripAreaId'

import {
  TripAreaNavigation,
  TripAreaNavigationIcon,
} from './TripAreaNavigation'

const LazyTripComponent = lazy(() => import('./TripArea'))

const TripComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyTripComponent />
  </SuspenseLoadingWrapper>
)

export const TripArea = {
  id: TripAreaId,
  requiredRight: BoumRight.AREA_TRIPS,
  Icon: TripAreaNavigationIcon,
  NavigationComponent: TripAreaNavigation,
  route: {
    path: TripAreaRoutes.route,
    component: TripComponent,
  },
}
